import React, { ComponentProps, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  ExpectRoot,
  Container,
  BackgroundImage,
  ContentWrapper,
  ExpectText1,
  ExpectText2,
  ExpectText3,
  ExpectText4,
  SquareImages,
  SectionTitle,
  DesktopWrapper,
  MobileWrapper,
  MobileContent,
  ExpectSquare,
  SquareImage,
  ButtonWrapper
} from './Expect.styles'
import { Text } from 'components/Text'
import Image from 'next/image'
import background from '../../../../../../public/assets/recipes/categories/individual/box-background.png'
import squares from '../../../../../../public/assets/recipes/categories/individual/expect-squares.png'
import mix from '../../../../../../public/assets/recipes/categories/individual/mixin.png'
import instructions from '../../../../../../public/assets/recipes/categories/individual/instructions.png'
import silicone from '../../../../../../public/assets/recipes/categories/individual/silicone-container.png'
import balanced from '../../../../../../public/assets/recipes/categories/individual/balanced.png'
import backgroundMobile from '../../../../../../public/assets/recipes/categories/individual/box-background-m.png'
import { CtaButton } from 'components/CtaButton'
import Link from 'next/link'

type ExpectProps = {}

export const Expect = (props: ExpectProps) => {
  const { t } = useTranslation()

  return (
    <ExpectRoot>
      <Container>
        <BackgroundImage>
          <DesktopWrapper>
            <Image src={background} alt={t('recipes:individual.expect.background-img')}/>
          </DesktopWrapper>
          <MobileWrapper>
          <Image src={backgroundMobile} alt={t('recipes:individual.expect.background-img')}/>
          </MobileWrapper>
        </BackgroundImage>
        <ContentWrapper>
          <SectionTitle>{t('recipes:individual.expect.title')}</SectionTitle>
          <ExpectText1>{t('recipes:individual.expect.feat-1')}</ExpectText1>
          <ExpectText2>{t('recipes:individual.expect.feat-2')}</ExpectText2>
          <ExpectText3>{t('recipes:individual.expect.feat-3')}</ExpectText3>
          <ExpectText4>{t('recipes:individual.expect.feat-4')}</ExpectText4>
          <SquareImages>
            <Image src={squares} alt={t('recipes:individual.expect.squares-img')}/>
          </SquareImages>
          <ButtonWrapper>
          <Link href='/meal-plan'>
            <CtaButton>{t('recipes:overview.cta-3')}</CtaButton>
          </Link>
          </ButtonWrapper>
        </ContentWrapper>
         <MobileContent>
            <SectionTitle>{t('recipes:individual.expect.title-m')}</SectionTitle>
          <ExpectSquare>
            <SquareImage>
              <Image src={balanced} alt={t('recipes:individual.expect.feat-1')}/>
            </SquareImage>
            <Text weight="medium" size="h4" color="quaternary-200">{t('recipes:individual.expect.feat-1')}</Text>
          </ExpectSquare>
          <ExpectSquare>
            <SquareImage>
              <Image src={mix} alt={t('recipes:individual.expect.feat-2')}/>
            </SquareImage>
            <Text weight="medium" size="h4" color="quaternary-200">{t('recipes:individual.expect.feat-2')}</Text>
          </ExpectSquare>
          <ExpectSquare>
            <SquareImage>
              <Image src={silicone} alt={t('recipes:individual.expect.feat-3')}/>
            </SquareImage>
            <Text weight="medium" size="h4" color="quaternary-200">{t('recipes:individual.expect.feat-3')}</Text>
          </ExpectSquare>
          <ExpectSquare>
            <SquareImage>
              <Image src={instructions} alt={t('recipes:individual.expect.feat-4')}/>
            </SquareImage>
            <Text weight="medium" size="h4" color="quaternary-200">{t('recipes:individual.expect.feat-4')}</Text>
          </ExpectSquare>
          <Link href='/meal-plan'>
            <CtaButton>{t('recipes:overview.cta-3')}</CtaButton>
          </Link>
        </MobileContent> 
      </Container>
    </ExpectRoot>
  )
}

Expect.displayName = 'Expect'
